module.exports = __webpack_public_path__ + "static/media/Executive_Committee_Agenda_5_28.97f27cda.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/26-27/Executive_Committee_Agenda_5_28.pdf
// module id = 258
// module chunks = 0